import { Component } from '@angular/core';
import { AuthenticationService } from './../services/authentication.service';
import { Observable } from 'rxjs';
import { Storage } from '@ionic/storage';
import { AngularDelegate, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-substitutionFilter',
  templateUrl: 'substitutionFilter.page.html',
  styleUrls: ['substitutionFilter.page.scss']
})
export class SubstitutionFilterPage {

  enableFilter: boolean;
  filter_id: number; 

  result:any=[];
  data: Observable<any>;
  user: Observable<any>;

  objects: any=[];

  constructor(private authService: AuthenticationService, private modalController: ModalController, private storage: Storage) { }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  ionViewWillEnter() {

    this.storage.get('substitution_options').then((options) => {
      
      if(options !== null) {
        
        this.enableFilter = options.filter;
        this.filter_id = options.filter_id;
      }
      
    });  
    
    this.getUsers();
  }


  getUsers() {

    this.authService.getFromEndpoint('user/account/linked_users?with=myself').subscribe(data => {
      this.objects = data;
      this.filter_id = data[0].id;
    })
  }

  submit() {

    var options = {
      "filter": this.enableFilter,
      "filter_id": this.filter_id,
    };
        
    this.modalController.dismiss(options);
  }

}
